class SearchForm extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input[type="search"]');

		if (this.input) {
			
			this.input.form.addEventListener("reset", this.onFormReset.bind(this));
      this.input.form.addEventListener("formdata", (event) => {
        const query = this.input.value.trim();

        if (query && !query.endsWith("*")) event.formData.set(this.input.name, `${query}*`);
      });
			this.input.addEventListener(
				"input",
				debounce((event) => {
					this.onChange(event);
				}, 300).bind(this),
			);
		}
	}

	shouldResetForm() {
		return !document.querySelector('[aria-selected="true"] a');
	}

	onFormReset(event) {
		// Prevent default so the form reset doesn't set the value gotten from the url on page load
		event.preventDefault();
		// Don't reset if the user has selected an element on the predictive search dropdown
		if (this.shouldResetForm()) {
			this.input.value = "";
			this.input.focus();
		}
	}
}

if (window.location.pathname === "/search") {
    const searchUrl = new URL(window.location.href);
    const searchQuery = searchUrl.searchParams.get("q");

    if (searchQuery?.endsWith("*")) {
        searchUrl.searchParams.set("q", searchQuery.slice(0, -1));
        window.history.replaceState({}, "", searchUrl);
    }
}

customElements.define("search-form", SearchForm);
